import { z } from 'zod';


export const WebpageSectionSchema = z.object({
  sectionTitle: z.string().min(1, 'Section title is required'),
  title: z.string().min(1, 'Title is required').nullable(),
  description: z.string().nullable(),
  contentType: z.string().min(1, 'Content type is required'),
  fileUrl: z.string().url('Invalid file URL').nullable(),
  emailAddress: z.string().email('Invalid email address').nullable(),  
  address: z.string().nullable(),
  phoneNumber: z.string().nullable(),
  phoneCountryCode: z.string().nullable(),
  listOfPurpose: z.array(z.string()).min(1, 'At least one entry is required').nullable(),
  sectionTag: z.string().min(1, 'Section tag is required'),
});

export type WebpageSectionSchemaType = z.infer<typeof WebpageSectionSchema>;


export const ContentWithFileFormDataSchema = WebpageSectionSchema.pick({
  title: true,
  description: true,
  fileUrl: true,
});
export type ContentWithFileFormData = z.infer<typeof ContentWithFileFormDataSchema>;

export const ContentWithoutFileFormDataSchema = WebpageSectionSchema.pick({
  title: true,
  description: true,
});
export type ContentWithoutFileFormData = z.infer<typeof ContentWithoutFileFormDataSchema>;

export const HeroImageFormDataSchema = WebpageSectionSchema.pick({
  fileUrl: true,
});
export type HeroImageFormData = z.infer<typeof HeroImageFormDataSchema>;

export const ContentWithCredentialsFormDataSchema = WebpageSectionSchema.pick({
  title: true,
  emailAddress: true,
  address: true,
  phoneNumber: true
});
export type ContentWithCredentialsFormData = z.infer<typeof ContentWithCredentialsFormDataSchema>;

export const ContentWithListFormDataSchema = WebpageSectionSchema.pick({
  sectionTitle: true,
  description: true,
  listOfPurpose: true
});
export type ContentWithListFormData = z.infer<typeof ContentWithListFormDataSchema>;